import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=5034815c&lang=pug&"
import script from "./Polls.vue?vue&type=script&lang=ts&"
export * from "./Polls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports